import {createSlice, PayloadAction} from '@reduxjs/toolkit';

import {TLandUnit} from 'App/features/map2DEntities/landUnits/landUnitsTypes';
import {RootState} from 'App/store/rootReducer';

type TFocusedInitsSlice = {
  focusedConsolidationLandUnit: TLandUnit | null;
};
const initialState: TFocusedInitsSlice = {
  focusedConsolidationLandUnit: null,
};
const focusedUnitsSlice = createSlice({
  name: 'focusedUnits',
  initialState,
  reducers: {
    toggleFocusedConsolidationLandUnit: (
      state,
      {payload}: PayloadAction<TLandUnit>,
    ) => {
      state.focusedConsolidationLandUnit =
        state.focusedConsolidationLandUnit?.gid !== payload.gid
          ? payload
          : null;
    },
    resetFocusedConsolidationLandUnit: state => {
      state.focusedConsolidationLandUnit = null;
    },
  },
});

export const selectFocusedConsolidationLandUnit = (
  state: RootState,
): TLandUnit | null =>
  state.map2DEntities.focusedUnits.focusedConsolidationLandUnit;

export const {
  toggleFocusedConsolidationLandUnit,
  resetFocusedConsolidationLandUnit,
} = focusedUnitsSlice.actions;
export default focusedUnitsSlice.reducer;
